<template>
  <ActListBox
    from="babe"
    :api="postActivityHots"
    :title="'VOTE'"
    :params="params" />
</template>
<script>
import { postActivityHots } from '@/api/babe'
import ActListBox from '@/components/ActListBox.vue'

export default {
  name: 'BabeVoteList',
  components: { ActListBox },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  data() {
    return {
      postActivityHots,
      params: { type: 12 }
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/views/babe/votelist.vue